module.exports = __webpack_public_path__ + "03ca51e7ee24087c9689f94af174c058.png";